// extracted by mini-css-extract-plugin
export default {"form":"ReportForm_form__l3tev","step-header":"ReportForm_step-header__0pock","errors-table":"ReportForm_errors-table__rO06j"};